var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8855 20H57.1164C62.8571 20 67.501 24.5548 67.501 30.1477V49.8521C67.501 55.445 62.8571 59.9998 57.1164 59.9998H22.8855C17.1448 59.9998 12.501 55.445 12.501 49.8521V30.1477C12.501 24.5548 17.1448 20 22.8855 20ZM16.0017 31.2596H64.0002V30.1477C64.0002 26.4233 60.902 23.406 57.1164 23.406H22.8855C19.0999 23.406 16.0017 26.4233 16.0017 30.1477V31.2596ZM64.0002 34.6657H16.0017V49.8521C16.0017 53.5765 19.0999 56.5938 22.8855 56.5938H57.1164C60.902 56.5938 64.0002 53.5765 64.0002 49.8521V34.6657Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7183 46H35.2817C36.492 46 37.5 46.9088 37.5 48C37.5 49.0912 36.492 50 35.2817 50H24.7183C23.508 50 22.5 49.0912 22.5 48C22.5 46.9088 23.508 46 24.7183 46Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.bf3c5438.svg";
export { ForwardRef as ReactComponent };